const Processing = () => {
  // Uppercase
  return (
    <div className='content-left-box'>
      <h2 className='text-gray letter-scrambler'>{'\\\\PROCESSING\\\\'}</h2>
      <p className="letter-scrambler">
        TO EXPERIMENT IS TO INVITE CHALLENGES, AND SOMETIMES, CHAOS.
        AND NOW, WE'RE INVITING YOU TO THE LAB TO WATCH IT ALL HAPPEN.
      </p>
      <br />
      <p className='text-gray'>{'<>'}</p>
      <p className="letter-scrambler paragraph-with-margin">
        AWAITING NEXT STEPS FROM USER...
      </p>
      <p className='text-gray'>{'<>'}</p>
    </div >
  )
};

export default Processing;
